import { GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { Get } from '../helpers';

const GetGreenroomInvitationsForMeeting = ({
  meeting,
}: {
  meeting: number;
}): Promise<GreenroomInviteUserResponse[]> => {
  return Get({
    host: import.meta.env.VITE_GREENROOM_API,
    path: `/v3/greenroom/invitations/${meeting}`,
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomInvitationsForMeeting;
